// Araç belgesi/bağı değişti: kayıt listesi + aracı gömen HER izin detayı (onay tüm izinlerde sayılır,
// §23) + kontrol aşaması detayları yeniden çekilir. Yalnız "bu izni" geçersiz kılmak bayat liste bırakır.
import type { QueryClient } from '@tanstack/react-query';
import { contractorsKeys } from './contractorsKeys';
import { departmentReviewKeys } from './departmentReviewKeys';
import { permitsKeys } from './permitsKeys';

export function invalidateVehicleCaches(queryClient: QueryClient, contractorUuid: string) {
  queryClient.invalidateQueries({ queryKey: contractorsKeys.vehicles(contractorUuid) });
  queryClient.invalidateQueries({ queryKey: permitsKeys.detailAll() });
  queryClient.invalidateQueries({ queryKey: permitsKeys.list() });
  queryClient.invalidateQueries({ queryKey: departmentReviewKeys.all() });
}
